'use es6';

import { NavMarker } from 'react-rhumb';
import { DOIConfirmationWrapper } from '../components/DOIConfirmationWrapper.styles';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DOIDefaultConfirmationContainer = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "DOI_DEFAULT_CONFIRMATION_PAGE_LOADED",
  children: /*#__PURE__*/_jsx(DOIConfirmationWrapper, {
    children: /*#__PURE__*/_jsx("h3", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "doiDefaultConfirmation.header"
      })
    })
  })
});
export default DOIDefaultConfirmationContainer;